import { createSlice } from "@reduxjs/toolkit";
import {
  getJobsByCreatorStatus,
  getCreatorJobById,
  applyJob,
  creatorJobAction,
} from "./jobCreatorService";

// Initial state
const initialState = {
  jobs: [],
  currentJob: null,
  loading: false,
  error: null,
};

// Job Creator slice
const jobCreatorSlice = createSlice({
  name: "jobCreator",
  initialState,
  reducers: {
    clearJobCreatorErrors: (state) => {
      state.error = null;
    },
    clearJobCreatorData: (state) => {
      state.jobs = [];
      state.currentJob = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Get Jobs by Creator Status
    builder
      .addCase(getJobsByCreatorStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobsByCreatorStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs = action.payload.data;
      })
      .addCase(getJobsByCreatorStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Job by ID
      .addCase(getCreatorJobById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCreatorJobById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentJob = action.payload.data;
      })
      .addCase(getCreatorJobById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Apply Job
      .addCase(applyJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(applyJob.fulfilled, (state, action) => {
        state.loading = false;

        // If the response includes the updated job data
        if (action.payload.data) {
          // If we have a jobs array and the response contains the job with an ID
          if (state.jobs.length > 0 && action.payload.data.id) {
            // Update the job in the jobs array if it exists
            state.jobs = state.jobs.map((job) =>
              job.id === action.payload.data.id ? action.payload.data : job
            );
          }

          // If the current job ID matches the applied job ID, update it as well
          if (
            state.currentJob &&
            state.currentJob.id === action.payload.data.id
          ) {
            state.currentJob = action.payload.data;
          }
        }
      })
      .addCase(applyJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Creator Job Action
      .addCase(creatorJobAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(creatorJobAction.fulfilled, (state, action) => {
        state.loading = false;

        // If the response includes the updated job data
        if (action.payload.data) {
          // If we have a jobs array and the response contains the job with an ID
          if (state.jobs.length > 0 && action.payload.data.id) {
            // Update the job in the jobs array if it exists
            state.jobs = state.jobs.map((job) =>
              job.id === action.payload.data.id ? action.payload.data : job
            );
          }

          if (
            state.currentJob &&
            state.currentJob.id === action.payload.data.id
          ) {
            state.currentJob = action.payload.data;
          }
        }
      })
      .addCase(creatorJobAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearJobCreatorErrors, clearJobCreatorData } =
  jobCreatorSlice.actions;
export default jobCreatorSlice.reducer;
